package com.essntl.features.message.data.repository

import com.essntl.core.utils.repository.Repository
import com.essntl.core.whatsapp.domain.WhatsappClient
import com.essntl.core.whatsapp.domain.models.WhapiChatTemplate
import com.essntl.features.message.data.supabase.conversation.ConversationSupabaseDataSource
import com.essntl.features.message.domain.model.WhapiChatModel
import com.essntl.features.message.domain.repository.ConversationRepository
import io.github.jan.supabase.realtime.RealtimeChannel

class ConversationRepositoryImpl internal constructor(
    private val whatsappClient: WhatsappClient,
) : Repository(), ConversationRepository {
    override suspend fun getWhapiChats(page: Long): Result<List<WhapiChatModel>> =
        whatsappClient.getWhapiChats(page = page)

    override suspend fun getWhapiChatById(chatId: String): Result<WhapiChatModel> =
        whatsappClient.getWhapiChatById(chatId = chatId)

    override suspend fun updateWhapiChat(chatId: String, markUnread: Boolean): Result<Unit> =
        whatsappClient.updateWhapiChat(
            chatId = chatId,
            chatTemplate = WhapiChatTemplate(
                markUnread = markUnread,
            ),
        )

    override suspend fun getWhapiGroups(): Result<List<WhapiChatModel>> =
        whatsappClient.getWhapiGroups()

    override suspend fun getWhapiGroupById(groupId: String): Result<WhapiChatModel> =
        whatsappClient.getWhapiGroupById(groupId)
}